<template>
  <!-- Tarjetas -->
  <div class="d-flex my-3">
    <Card
      :data="item"
      v-for="(item, index) in dataCard"
      :key="index"
      :style="index > 0 ? [{ 'margin-left': '10px' }] : ''"
    />
  </div>
</template>

<script>
import Card from "../../components/common/Card";

export default {
  data() {
    return {
      // data card
      dataCard: [
        { number: 150, text: "Total Conectados", icon: "fas fa-star" },
        { number: 59, text: "Total Usuarios", icon: "fas fa-users" },
        { number: 123, text: "Total Filiales", icon: "fas fa-briefcase" },
        { number: 65, text: "Total Clientes", icon: "fas fa-building" },
      ],
    };
  },
  components: {
    Card,
  },
};
</script>

<style></style>
